import { Actions, createEffect, ofType} from '@ngrx/effects';
import {Injectable} from '@angular/core';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {GET_CBC_FORMS, GetCbcFormsAction, GetCbcFormsSuccessAction} from '@features/spreadsheet/store/spreadsheet.action';
import {mergeMap, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';

@Injectable()
export class SpreadsheetEffects {

  constructor (private actions$: Actions,
               private platformQueryService: PlatformQueryService) {
  }


  getCbcFormsSuccess$ = createEffect(() => this.actions$
    .pipe( ofType(GET_CBC_FORMS) )
    .pipe(
      mergeMap((action: GetCbcFormsAction) => {
        const query = new PlatformQuery();
        query.name = 'GetCbcFormsQuery';
        query.api = Api.Spreadsheet;
        query.setValue('CountryCode',  action.countryCode);
        return this.platformQueryService.executeQuery(query).pipe(
          map((response: any) => {
            const cbcForms = response.fieldValues['CbcForms'];
            return new GetCbcFormsSuccessAction(action.countryCode, cbcForms);
          })
          // ,
          // catchError(error => {
          //   //this.fuseSplashScreenService.hide();
          //   return of(new GetChapterDocumentFailedAction(action.documentDefinitionId, error));
          // })
        );
      })
    ));

}
